import { render, staticRenderFns } from "./FooterIcon1.vue?vue&type=template&id=a403f88a&scoped=true&"
var script = {}
import style0 from "./FooterIcon1.vue?vue&type=style&index=0&id=a403f88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a403f88a",
  null
  
)

export default component.exports